module.exports = __webpack_public_path__ + "static/media/Poster_Pionierinnen.80439858.pdf";